import { VisitReason } from '../interfaces/visit-reason';
import { TreatmentType } from '../enums';


export class VisitReasonModel implements VisitReason  {
    ID: number;              // PricelistCode.ID      
    PriceListRefID: number;  // PriceListRef.ID
    Name: string;            // PriceListCode.Name
    Code: string;
    Duration: number;        // PriceListCode.Duration
    Price?: number;          // 
    CategoryID: number;
    DepartmentID: number;
    PriceListID: number;
    SubCodeCount?: number;
    SubCodeID?: number;
    TypeID: TreatmentType;
    Description: string;
    FinalPrice?: number;
    Active: boolean;  
    TreatmentID?: number;  

    constructor(obj?: any) {
        this.ID = obj && obj.ID || 0; 
        this.PriceListRefID = obj && obj.PriceListRefID || 0;
        this.Name = obj && obj.Name || ''; 
        this.Code = obj && obj.Code || '';
        this.Duration =obj && obj.Duration || 5; 
        this.Price = obj && obj.Price || null;
        this.CategoryID = obj && obj.CategoryID || 0;
        this.DepartmentID = obj && obj.DepartmentID || 0;
        this.PriceListID = obj && obj.PriceListID || 0;
        this.SubCodeCount = obj && obj.SubCodeCount || null;
        this.SubCodeID = obj && obj.SubCodeID || null;
        this.TypeID = obj && obj.TypeID || TreatmentType.Treatment;
        this.Description = obj && obj.Description || '';
        this.FinalPrice = obj && obj.FinalPrice || null;
        this.Active = obj && obj.Active || true;
        this.TreatmentID = obj && obj.TreatmentID || null;

        if(obj && obj.TreatmentName){
            this.Name = obj.TreatmentName;
        }

    }
}